import { createFileRoute } from "@tanstack/react-router";
import CustomerDashboardLayout from "@/components/customer/CustomerDashboardLayout";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/my-account")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/my-account' }),
  component: () => <CustomerDashboardLayout />,
});
